<script>
import TablePage from '../../../../components/table_page';
// 新增用户
import addUser from '../../../mdm/views/user_management/form/add_user/index';

export default {
  extends: TablePage,
  components: {
    addUser,
  },
  data() {
    return {
      tablePage: {
        pageSize: 8,
      },
      configs: {
        pagination: false,
        tableConfig: {
          border: 'inner',
        },
      },
      params: {
        pageNum: 1,
        pageSize: 15,
      },
      isCalculateHeight: false,
    };
  },
  created() {
    this.getConfigList('user_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'process_immediately') {
        this.formName = 'addUser';
        this.formConfig = { ...row, code: val.code };
        if (row.businessType === '0') {
          this.modalConfig.title = '入职';
        } else if (row.businessType === '1') {
          this.modalConfig.title = '调岗';
        } else if (row.businessType === '2') {
          this.modalConfig.title = '离职';
        } else {
          this.modalConfig.title = '企业用户';
        }
        this.openFull();
      }
    },
  },
};
</script>
